import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Modal } from 'antd';
import { StarOutlined } from '@ant-design/icons';
import UpgradeAlert from '../features/UpgradeAlert';
import config from '../../../config';

const UpgradeModal = ({ headlinerUpgradeModalVisible, setHeadlinerUpgradeModalVisible }) => {
  return (
    <Modal
      title={
        <>
          <StarOutlined />{' '}
          <FormattedMessage defaultMessage="Create promo videos from your episodes" />
        </>
      }
      footer={null}
      width={1200}
      open={headlinerUpgradeModalVisible}
      onCancel={() => setHeadlinerUpgradeModalVisible(false)}
      destroyOnClose
    >
      <UpgradeAlert updateFrom="headliner" />
      <Row gutter={48}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <b>
            <FormattedMessage defaultMessage="Headliner lets you create stunning audio visualization for easy sharing to your social media channels, so fans can engage with your show." />{' '}
          </b>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Row align="middle" justify="center" style={{ overflow: 'hidden' }}>
            <img src={`${config.staticCDN}/images/headliner.gif?${Date.now()}`} />
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

UpgradeModal.propTypes = {
  headlinerUpgradeModalVisible: PropTypes.bool.isRequired,
  setHeadlinerUpgradeModalVisible: PropTypes.func.isRequired,
};

export default UpgradeModal;
